const FREESPEE_ENDPOINT = '/rest/{userId}/number/dealer';

export default class FreespeeDynamicDealer {

    /**
     * @param element
     * @param gtm
     */
    constructor(element, gtm, w) {
        this.window = w || window;
        this.$element = $(element);
        this.gtm = gtm;
        this.userId = this.$element.data('freespee-dynamic-dealer');
        this.extraparam = this.$element.data('extraparam');
        this.$textElement = this.$element.find('[data-text-phone-number]');
        this.breakpoint = 767;
        this.csrfToken = $('meta[name="_csrf"]').attr('content');
        this.setup();
    }

    setup() {
        this.$element.off('click').on('click', (event) => {
            if(!this.$element.data('freespee-link').startsWith('tel:')) {
                $.ajax({
                    url: FREESPEE_ENDPOINT.replace('{userId}', this.userId),
                    type: 'POST',
                    headers: {
                        'X-CSRF-Token': this.csrfToken
                    },
                    success: (data) => {
                        if (this.quickCall()) {
                            window.location.href = 'tel:' + data.number;
                            this.gtm.trackEvent('R2SPhoneBegin', this.extraparam);
                        } else {
                            if (!this.$element.data('freespee-link').startsWith('tel:')) {
                                this.gtm.trackEvent('R2SPhoneBegin', this.extraparam);
                                this.$textElement.text(data.number);
                                this.$element.data('freespee-link', 'tel:' + data.number);
                            }
                        }
                    }
                });
            }
        });
    }

    quickCall() {
        return window.matchMedia(`(max-width: ${this.breakpoint}px)`).matches;
    }

}
